export const getListForWhatsapp = order => {
    return encodeURI(getProductList(order))
}

export const getProductList = order =>
    order.reduce((acc, item) => {
        return `${acc}${item.quantity} x ${item.Nombre}\n`
    }, '')
